export function formatWalletAddress(value) {
  const safe = String(value || "").trim();
  if (!safe) return "";
  if (safe.length <= 12) return safe;
  return `${safe.slice(0, 6)}...${safe.slice(-6)}`;
}
